/* eslint 'no-array-constructor': 'off', eqeqeq: 'off'  */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Button,Table,Modal} from 'reactstrap';
import classnames from 'classnames';
import SelectAllCheckboxes from '../../../../../../Resources/SelectAllCheckboxes';
import DeleteConfirmation from '../../_ModalsForms/DeleteConfirmation';
import ErrorGif from '../../../../../../Assets/images/Error.gif';
import {DeleteCharges } from '../../../../../../action/tenantAction';
import AddFixedCharges from '../../_ModalsForms/AddFixedCharges';
import Currencies from '../../../../../../Resources/Currencies';
import * as ErrorMessage from '../../../../../../Resources/ErrorMessages';
import { closeModalPopUp } from '../../../../../../action/modalStateAction';
import Conversions from '../../../../../../Resources/Conversions';

let EditFixedChargeDetails = [];
class ViewFixedCharges extends Component {

  constructor(props){
    super(props);
    this.state = {
      fixed_charges : this.props.FixedCharges_response,
      error_msg: false,
      modal: false,
      deletemodal: false,
      records_selected : new Array(),
      tenant_ID : this.props.tenantID_Reducer,
      IsEdit: false,
      sort:{
        column: 'fixedChargeName',
        direction: [
          {name:'fixedChargeName', direction: 'asc', onclick: true},
          {name: 'fixedRate', direction: 'desc', onclick: false}
        ]
      },
      IsDefaultSort: true, 
      IsChangesSaved: false,
    };
    this.toggle = this.toggle.bind(this);
    this.Deletetoggle = this.Deletetoggle.bind(this);
    this.ViewFixedRtDetails = this.ViewFixedRtDetails.bind(this);
}

ViewFixedRtDetails(Id,Name,Rate){
  EditFixedChargeDetails = [];
  EditFixedChargeDetails.push({fixedChargeId:Id,fixedChargeName:Name,fixedRate:Rate});
  this.setState({
    modal: true, IsEdit: true
  });
}

toggle() {
  EditFixedChargeDetails = [];
  this.setState({
      modal: !this.state.modal, IsEdit: false
  });
}

Deletetoggle() {
  this.setState({
    deletemodal: !this.state.deletemodal
  });
}

componentWillReceiveProps(nextProps) {
  if(this.props != nextProps) {
    var modalClose =nextProps.ModalOpenCloseResponse.ModalOpenClose.modal_open;
    if(modalClose=="close"){
      this.setState({  
        fixed_charges : nextProps.FixedCharges_response,
        tenant_ID: nextProps.tenantID_Reducer,
        modal: false,
        IsChangesSaved: true
      });
    }
    else{
      this.setState({  
        fixed_charges : nextProps.FixedCharges_response,
        tenant_ID: nextProps.tenantID_Reducer
      });
    }
  }
}



   /* Delete Fixed Charges*/

DeleteFixedCharges(){
  this.setState({ error_msg: false });
  var Data =this.state.records_selected;
  var checkboxes = document.getElementsByClassName('fixed_charges_records');
  for (var i = 0; i < checkboxes.length; i++) {
    if  (checkboxes[i].checked === true) {
        var fixedCharge_ID_to_be_deleted = {
            "fixedChargeId" : checkboxes[i].id 
        }
        
   Data.push(fixedCharge_ID_to_be_deleted);
    } 
    
   }

   if(Data.length>0){
        this.setState({ error_msg: false });
        this.Deletetoggle();
        
     }
       else{
          this.setState({ error_msg: true });
       }
}



   Delete = (returnVal) => {
    if(returnVal=="yes"){
      var Data =this.state.records_selected;
      var tenantID = this.state.tenant_ID;
       if(Data.length>0 && tenantID>0){
        this.props.DeleteCharges(tenantID, Data);
       }
  this.setState({ records_selected: new Array() });
       Data = null;
    }
    this.Deletetoggle();
}

onSort = (column) => (e) => {
  this.setState({IsDefaultSort:false});
  var SortData = this.state.sort.direction;
  var selected = SortData.filter(a => a.name == column);
  const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
  var data_from_state = this.state.fixed_charges;
  var notequals = 0;

  if(data_from_state != null){
    const sortedData = this.state.fixed_charges.sort((a, b) => {
        const nameA = (column !== "fixedRate") ? a[column].toLowerCase() : a[column];
        const nameB = (column !== "fixedRate") ? b[column].toLowerCase() : b[column];
        if (nameA < nameB) {
            notequals = 1;
            return -1;
        }
        if (nameA > nameB) {
            notequals = 1;
            return 1;
        }
        if (nameA == nameB) {
            return 0;
        }
        return 0;
    });

    if(selected[0].direction =='asc' && notequals == 1){
      sortedData.reverse();
    }
    SortData.map(x => (x.name !== column) ? x.onclick = false : x.onclick = true);
    SortData.map(x => (x.name !== column) ? x.direction = SortData.filter(m => (m.name === x.name))[0].direction : x.direction = direction);

    this.setState({
        sort: {
            column,
            direction:SortData,
        }
    });
  }
}

setArrow = (column) => {
  let className = 'workorder-sort-direction';
  let sortColumn = this.state.sort.direction.filter(x => (x.name === column))[0];
  className += (sortColumn.onclick === true) ? (sortColumn.direction === 'asc') ? ' asccolor' : ' desccolor' : ' desc';
  return className;
};

    render(CurrencyID, getLabels, UserPreference_response, UserCanEdit) {
      let data, fixedCharges,Error_Message= null, CurrencySym = '$';
      data = this.state.fixed_charges;
      let label = this.props.getLabels;
      let PreferedDateFormat = this.props.UserPreference_response;

      if(this.props.CurrencyID != undefined && this.props.CurrencyID != null && this.props.CurrencyID != ""){
        CurrencySym = Currencies.CurrencySymbol(this.props.CurrencyID);
      }
      let lUserCanEdit = this.props.UserCanEdit;
      lUserCanEdit = lUserCanEdit !== undefined && lUserCanEdit !== null && lUserCanEdit ? true : false;
      

      if (data != undefined && data.length > 0) {
        if(this.state.IsDefaultSort){
            data.sort((a,b)=>{
              let nameA = a['fixedChargeName'].toLowerCase();
              let nameB = b['fixedChargeName'].toLowerCase();
              if(nameA < nameB){
                  return -1;
              }
              if(nameA > nameB){
                  return 1;
              }
              if(nameA == nameB){
                  return 0;
              }
              return 0;
            });
          }
          if(this.state.IsChangesSaved){
            data.sort((a,b)=>{
              let nameA = (this.state.sort.column !== "fixedRate") ? a[this.state.sort.column].toLowerCase() : a[this.state.sort.column];
              let nameB = (this.state.sort.column !== "fixedRate") ? b[this.state.sort.column].toLowerCase() : b[this.state.sort.column];
              if(nameA < nameB){
                  return -1;
              }
              if(nameA > nameB){
                  return 1;
              }
              if(nameA == nameB){
                  return 0;
              }
              return 0;
            });
            if(this.state.sort.direction.filter(x => x.name === this.state.sort.column)[0].direction === "desc"){
                data.reverse();
            }
            this.setState({IsChangesSaved: false});
          }
        fixedCharges  = data.map(el => (
          <tr id={el.fixedChargeId}><td><input type="checkbox"   id={el.fixedChargeId}   className="fixed_charges_records" /></td>
          {
            lUserCanEdit ? <td onClick={() => {this.ViewFixedRtDetails(el.fixedChargeId,el.fixedChargeName,el.fixedRate)}} style={{color:'#6890C6'}} className="link_cursor">{el.fixedChargeName}</td> :
            <td className="link_cursor">{el.fixedChargeName}</td> 
          }
          <td style={{"font-family":"Arial"}}>{CurrencySym + " " + Conversions.formatNumber(PreferedDateFormat,el.fixedRate)}</td></tr>
          // <td> {CurrencySym + " " + el.fixedRate}</td></tr>
        ));
      }
      else{
        fixedCharges = <tr><td colSpan="3">No Records Found</td></tr>
      }

      (this.state.error_msg == true) ?  Error_Message =  <p  className="error_msg"> <img src={ErrorGif} alt="Trane Logo" />  {ErrorMessage.Fixed_charges_error}</p>  : Error_Message= " ";

      return (
        <div>
          <div className="main_container">
          {Error_Message}
          <div className="buttons_container">
              <Button type="button" hidden={!lUserCanEdit} className="btn btn-black" onClick={()=>this.DeleteFixedCharges()}>{label['ManageHolidays.Delete.Text'] !== undefined ? label['ManageHolidays.Delete.Text'] : "Delete"} </Button>
              <Button type="button" hidden={!lUserCanEdit} className="btn btn-success" onClick={this.toggle} >{label['FixedRateSetup.AddFixedRate.Text'] !== undefined ? label['FixedRateSetup.AddFixedRate.Text'] : "Add Fixed Charge"}</Button>
            </div>
            <div className="table_container">
              <Table striped responsive className="Custom_table table_border">
                <tbody className="cell_container tenant_cell">
                  <tr>
                    <th><input type="checkbox" className="header_Check_box" onClick={() => { SelectAllCheckboxes.selectAllCheckbox("fixed_charges_records","header_Check_box"); }} /></th>
                    <th onClick={this.onSort('fixedChargeName')}>{label['ManageHolidays.Name.Text'] !== undefined ? label['ManageHolidays.Name.Text'] : "Name"}<span className={this.setArrow('fixedChargeName')}></span></th>
                    <th onClick={this.onSort('fixedRate')}>{label['TenantConsumption.Charges.Text'] !== undefined ? label['TenantConsumption.Charges.Text'] : "Charge"}<span className={this.setArrow('fixedRate')}></span></th>
                  </tr>
                  {fixedCharges}
                </tbody>
              </Table>
            </div>
          </div>
            <Modal isOpen={this.state.modal} className={classnames({ classnames: this.props.className }, "ModalContainer short_modal")} >
                    <AddFixedCharges parentToChildData={[this.state.IsEdit, EditFixedChargeDetails]} />
            </Modal>
            <Modal isOpen={this.state.deletemodal} deletemodal={this.deletemodal} className={classnames({ classnames: this.props.className }, "ModalContainer")} >
                    <DeleteConfirmation parentToChildData={["Delete Fixed Charge","You are about to delete a fixed charge. Do you want to continue?"]}  Delete = {this.Delete}   />
            </Modal>
        </div>
      );
    }
    }

const mapStateToProps = state => {
      return {
        FixedCharges_response: state.ViewtenantsRootReducer.FixedCharges.FixedCharges,
        tenantID_Reducer: state.ViewtenantsRootReducer.FixedCharges.tenantId,
        CurrencyID: state.ViewtenantsRootReducer.CompanyInformation.currencyId,
        ModalOpenCloseResponse: state.ModalOpenCloseRootReducer,
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference,
        UserPreference_response: state.userPreferencesRootReducer.UserPreference,
        UserCanEdit: state.authService.HasApplicationFullAcess
      };
    };
    

const mapDispatchToProps = dispatch => {
  return {
   DeleteCharges: (tenantID, data) => dispatch(DeleteCharges(tenantID, data)),
   closeModalPopUp: (modaldata) => dispatch(closeModalPopUp(modaldata))
  };
};

    
export default connect(mapStateToProps, mapDispatchToProps)(ViewFixedCharges);




